import { createFileRoute } from "@tanstack/react-router";
import AdminGuidesPage from "@/pages/admin/guides";

export const Route = createFileRoute("/app/admin/guides")({
  component: AdminGuidesPage,
});
